export const ticketMessagesSectionSelectors = {
  container: 'ticket-messages-suggestions-container',
  messageInput: 'ticket-message-input',
  sendButton: 'ticket-message-send-button',
  suggestion: (id: string) => `ticket-message-suggestion-${id}`,
  suggestions: new RegExp(`ticket-message-suggestion-\\d+`),
  selectedSuggestion: 'ticket-message-selected-suggestion'
};
